export default __webpack_public_path__ + "content/media/32.a1e8686b.jpg";